var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-chip',{staticClass:"ag-grid-cell-chip",attrs:{"color":_vm.options[_vm.params.value].color}},[_c('span',[_vm._v(_vm._s(_vm.options[_vm.params.value].label))])])}
var staticRenderFns = []

export { render, staticRenderFns }